module.exports = __webpack_public_path__ + "img/02.cc8b0697.png";